import React from "react";
import { Col, Page, Row, Typography } from "@payping/web-components";

import { buildUrl } from "@payping/utilities-shared/url";
import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "@/assets/scss/Shop/Product/groupCreate.module.scss";
import Uploader from "./Upload";
import { URLS } from "@payping/utilities-shared/consts";

const CreateBulk: React.FC = () => {
  const { t } = useAppTranslation();

  return (
    <Page>
      <Row justify={"center"} className={styles.container}>
        <Col xs={24} md={20} lg={16} xl={12}>
          <Row className={"tw:w-full"}>
            <Col span={24} className={styles.groupCreateTip}>
              <Typography.Text>{t("product.createBulk.createBulkTip")}</Typography.Text>
              <Typography.Link download href={buildUrl(URLS.STORAGE_URL, "PayPing_Items_Template.xls").toString()}>
                {t("product.createBulk.downloadSampleFile")}
              </Typography.Link>
            </Col>
            <Col span={24}>
              <Typography.Paragraph>
                <ul>
                  {[...(t("product.createBulk.warnings", { returnObjects: true }) as Array<any>)].map(
                    (warning: string, index: number) => (
                      <li key={`${index}`}>
                        <Typography.Text>{warning}</Typography.Text>
                      </li>
                    ),
                  )}
                </ul>
              </Typography.Paragraph>
            </Col>
            <Col span={24} className={styles.uploadContainer}>
              <Uploader />
            </Col>
          </Row>
        </Col>
      </Row>
    </Page>
  );
};

export default CreateBulk;
